<template>
<header>
  <nav>
    <div class="logo-container">
      <a href="https://montanacorporate.com">
        <img src="@/assets/logo-white.svg" alt="Montana Corporate Logo" />
      </a>
    </div>
    <div class="nav-links-container">
      <ul>
        <li><a href="https://montanacorporate.com">Exit Portal</a></li>
      </ul>
    </div>
  </nav>
</header>
</template>

<script>

  export default {
    name: 'Header',
  };
</script>

<style lang="scss" scoped>

header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #0e436f;
  width: 100%;
  position: relative;

  nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    padding: 1rem 2rem;
    z-index: 2;
    background-color: transparent;
    box-sizing: border-box;
    max-width: clamp(1300px, 90vw, 1716px);;

    .logo-container {
      img {
        width: 11rem;
        cursor: pointer;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 0.6;
        }
      }
    }


    .nav-links-container {
      ul {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: clamp(1.5rem, 3vw, 3.5rem);
      }

      li {
        list-style: none;
        white-space: nowrap;
        position: relative;

        a {
          text-decoration: none;
          color: white;
          font-size: 1.125rem;
          font-weight: 500;
          transition: opacity 0.2s ease;

          &:not(.primary-button):hover {
            opacity: 0.6;
          }

          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}

</style>